// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"0d4846cb","251":"927a6ed3"}[chunkId] + ".chunk.js";
};